import React from "react";

interface PanelProps {
  Header: React.ReactNode;
  children: React.ReactNode;
}

const Panel: React.FC<PanelProps> = ({ Header, children }) => {
  return (
    <div className="bg-white border border-gray-300">
      <div className="bg-gray-200 text-white flex justify-between items-center">
        <div className=" px-3 py-1 font-extralight text-2xl w-full">
          {Header}
        </div>
      </div>
      <div className="px-3 py-2">{children}</div>
    </div>
  );
};

export default Panel;
